// extracted by mini-css-extract-plugin
module.exports = {"container":"MoneyInput_container__TzM8u","symbol":"MoneyInput_symbol__1fwZx","input":"MoneyInput_input__NYn_c"};